import { createContext } from 'react';
import type { ReactElement } from 'react';

export const NotFoundContext = createContext<ReactElement | null>(null);
